import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { brand, navLinks } from "../../mock";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) window.scrollTo({ top: el.offsetTop - 70, behavior: "smooth" });
};

export const useGoToSection = () => {
  const nav = useNavigate();
  const loc = useLocation();
  return (id) => (loc.pathname === "/" ? scrollToId(id) : nav("/", { state: { scrollTo: id } }));
};

export const Logo = () => {
  const go = useGoToSection();
  return (
  <button onClick={() => go("home")} className="flex items-center gap-2.5" data-testid="logo">
    <span className="w-9 h-9 bg-yellow-400 text-black font-display font-bold text-2xl flex items-center justify-center rounded-[3px]">P</span>
    <span className="font-display font-bold text-[26px] tracking-tighter text-white">{brand.name}</span>
  </button>
  );
};

export default function Header({ onQuote }) {
  const [active, setActive] = useState("home");
  const [open, setOpen] = useState(false);
  const go = useGoToSection();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/") { setActive(pathname.startsWith("/projects") ? "projects" : ""); return; }
    const onScroll = () => {
      let cur = "home";
      navLinks.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 140) cur = id;
      });
      setActive(cur);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-[11.5%] h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`relative text-[14px] uppercase tracking-wide transition-colors duration-200 ${active === l.id ? "text-yellow-400" : "text-white hover:text-yellow-400"}`}
            >
              {l.label}
              <span className={`absolute -bottom-1.5 left-0 h-[2px] bg-yellow-400 transition-[width] duration-300 ${active === l.id ? "w-full" : "w-0"}`} />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={onQuote}
            data-testid="header-get-quote"
            className="hidden sm:flex items-center gap-2 bg-white text-black rounded-full px-6 py-2.5 text-[14px] font-semibold tracking-[0.12em] hover:bg-yellow-400 transition-colors duration-200"
          >
            <Phone className="w-3.5 h-3.5 fill-black" /> GET QUOTE
          </button>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-[#0a0a0a] border-t border-white/10 px-6 py-4 flex flex-col gap-1">
          {navLinks.map((l) => (
            <button key={l.id} onClick={() => { go(l.id); setOpen(false); }} className="text-left py-3 text-white/90 hover:text-yellow-400 border-b border-white/5">
              {l.label}
            </button>
          ))}
          <button onClick={() => { onQuote(); setOpen(false); }} className="mt-3 bg-yellow-400 text-black rounded-full py-3 font-semibold">GET QUOTE</button>
        </div>
      )}
    </header>
  );
}
